import { UserRoles } from 'domains/user/UserRoles'

export const UserAccessPermissionsST = {
  SUPPORT_TOOL_ACCESS: 'SUPPORT_TOOL_ACCESS',
  SUPPORT_TOOL_EDIT_PERMISSIONS: 'SUPPORT_TOOL_EDIT_PERMISSIONS',
  SUPPORT_TOOL_CREATE_ADMIN: 'SUPPORT_TOOL_CREATE_ADMIN',
}

export const UserAccessPermissionsCMS = {
  CMS_ACCESS: 'CMS_ACCESS',
}

export const UserAccessPermissionsDTX = {
  DTX_ACCESS: 'DTX_ACCESS',
}

export const UserAccessPermissionsPHI = {
  DTX_PHI_DATA_ACCESS_WRITE: 'DTX_PHI_DATA_ACCESS_WRITE',
  DTX_PHI_DATA_ACCESS_READ_ONLY: 'DTX_PHI_DATA_ACCESS_READ_ONLY',
  DTX_PHI_DATA_ACCESS_READ_NAMES_ONLY: 'DTX_PHI_DATA_ACCESS_READ_NAMES_ONLY',
}

export const UserAccessPermissions = {
  ...UserAccessPermissionsST,
  ...UserAccessPermissionsCMS,
  ...UserAccessPermissionsDTX,
  ...UserAccessPermissionsPHI,
} as const

export type UserAccessPermissions =
  (typeof UserAccessPermissions)[keyof typeof UserAccessPermissions]

export const ROLE_BASED_PERMISSIONS: Record<'' | UserRoles, UserAccessPermissions[]> = {
  '': [], // No role
  ROLE_USER_ADMIN: [
    UserAccessPermissions.SUPPORT_TOOL_ACCESS,
    UserAccessPermissions.SUPPORT_TOOL_EDIT_PERMISSIONS,
    UserAccessPermissions.SUPPORT_TOOL_CREATE_ADMIN,
    UserAccessPermissions.CMS_ACCESS,
    UserAccessPermissions.DTX_ACCESS,
  ],
  ROLE_NORMAL: [],
  ROLE_STAFF: [],
  ROLE_OPERATOR: [],
  ROLE_DIGITAL_REP: [],
  ROLE_FIELD_REP: [],
}
